<template>
  <div class="box box-success">
    <div class="box-header with-border">

      <h3 class="box-title box-title-sub"><img src="/static/img/icons/almacen-verde.png"> Almacén</h3>
    </div>
    <div v-if="isMounted" class="box-body">
      <div class="row">
        <div class="col-lg-4">
          <b>Recibido</b>
          <div class="row">
            <div class="col-lg-3">
              <div class="row" style="padding-top:30px;">
                <div class="col-lg-12">
                  <div style="width: 150px;" class="center-block">
                    <chart-projection-received ref="chartReceived" :chart-data="projectionChartDataReceived" :width="100" :height="100"></chart-projection-received>
                  </div>
                </div>
              </div>
              <br/>
              <div class="row">
                <div class="col-sm-12 col-md-12">
                  <div style="width: 150px;" class="text-center center-block">
                    <img src="/static/img/icons/ic_storage_arrived@3x.png" style="vertical-align: text-bottom" alt="Ingresadas" height="20" width="20">
                    <span class="span-value" v-bind:style="formatAmountColor(this.fetchData.recivedPercentageWarehouse)">
                      {{this.fetchData.recivedAmountWarehouse | formatAmount}}<span style="font-size: 14px"> {{this.fetchData.minimumStockUnit}}</span>
                    </span>
                    <br/>
                    <span class="span-status">Recibido</span>
                  </div>
                </div>
                <div class="col-sm-12 col-md-12">
                  <div style="width: 150px;" class="text-center center-block">
                    <i class="fa fa-bullseye" v-bind:style="{color: this.colorProjected}"></i>
                    <span class="span-value" v-bind:style="{color: this.colorProjected}">
                      {{this.fetchData.recivedAmountProjectionWarehouse | formatAmount}}<span style="font-size: 14px"> {{this.fetchData.minimumStockUnit}}</span>
                    </span>
                    <br/>
                    <span class="span-status">Proyectado</span>
                  </div>
                </div>
              </div>
              <br/>
            </div>
            <br>
            <div class="col-lg-9 chartPadding">
              <chart-line-return :chart-data="lineChartDataReceived" :height="240"></chart-line-return>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <b>Despachado</b>
          <div class="row">
            <div class="col-lg-3">
              <div class="row" style="padding-top:30px">
                <div class="col-lg-12">
                  <div style="width: 150px;" class="center-block">
                    <chart-projection-shipped ref="chartShipped" :chart-data="projectionChartDataShipped" :width="100" :height="100"></chart-projection-shipped>  
                  </div>
                </div>
              </div>
              <br/>
              <div class="row">
                <div class="col-sm-12 col-md-12">
                  <div style="width: 150px;" class="text-center center-block">
                    <img src="/static/img/icons/ic_storage_shipped@3x.png" style="vertical-align: text-bottom" alt="Ingresadas" height="20" width="20">
                    <span class="span-value" v-bind:style="formatAmountColor(this.fetchData.shippedPercentageWarehouse)">
                      {{this.fetchData.shippedAmountWarehouse | formatAmount}}<span style="font-size: 14px"> {{this.fetchData.minimumStockUnit}}</span>
                    </span>
                    <br/>
                    <span class="span-status">Despachado</span>
                  </div>
                </div>
                <div class="col-sm-12 col-md-12">
                  <div style="width: 150px;" class="text-center center-block">
                    <i class="fa fa-bullseye" v-bind:style="{color: this.colorProjected}"></i>
                    <span class="span-value" v-bind:style="{color: this.colorProjected}">
                      {{this.fetchData.shippedAmountProjectionWarehouse | formatAmount}}<span style="font-size: 14px"> {{this.fetchData.minimumStockUnit}}</span>
                    </span>
                    <br/>
                    <span class="span-status">Proyectado</span>
                  </div>
                </div>
              </div>
              <br/>
            </div>
            <br>
            <div class="col-lg-9 chartPadding">
              <chart-line-return :chart-data="lineChartDataShipped" :height="240"></chart-line-return>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <b>Devolución</b>
          <div class="row">
            <div class="col-lg-3">
              <div class="row" style="padding-top:100px;">
                <div class="col-lg-12">
                  <div style="width: 170px;" class="center-block">
                    <div style="width: 170px;" class="pull-left text-center">
                      <img src="/static/img/icons/ic_returned@3x.png" style="vertical-align: text-bottom" alt="Ingresadas" height="20" width="20">
                      <span class="span-value" v-bind:style="{color: this.colorReturned}">
                        {{this.fetchData.returnedAmountWarehouse | formatAmount}}<span style="font-size: 14px"> {{this.fetchData.minimumStockUnit}}</span>
                      </span>
                      <br/>
                      <span class="span-status">Devoluciones</span>
                    </div>
                  </div> 
                </div>
              </div>
            </div>
            <br>
            <div class="col-lg-9 chartPadding">
              <chart-line-return :chart-data="lineChartDataReturn" :height="240"></chart-line-return>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import util from 'assets/js/util.js'
import constants from 'assets/js/constants.js'

import DoughnutChart from 'charts/DoughnutChart.js'
import LineChart from 'charts/LineChart.js'

export default {
  name: 'WarehouseMain',
  props: [
    'mode',
    'fetchData'
  ],
  data () {
    return {
      isMounted: false,
      // Charts
      projectionChartDataReceived: null,
      lineChartDataReceived: null,
      projectionChartDataShipped: null,
      lineChartDataShipped: null,
      lineChartDataReturn: null,
      // Colors
      colorReceived: '',
      colorShipped: '',
      colorProjected: '',
      colorReturned: ''
    }
  },
  watch: {
    fetchData: function (newVal, oldVal) {
      this.fillData()
    }
  },
  computed: {
    ...mapGetters([
      'dashboardFilter'
    ])
  },
  created () {
    this.colorReceived = constants.colorPalette.WarehouseReceived
    this.colorShipped = constants.colorPalette.WarehouseShipped
    this.colorProjected = constants.colorPalette.Projected
    this.colorReturned = constants.colorPalette.WarehouseReturned
  },
  mounted () {
    this.isMounted = true
    this.fillData()
  },
  methods: {
    fillData () {
      this.formatChartReceived()
      this.formatChartShipped()
      this.formatChartReturned()
    },
    formatChartReceived () {
      // Recibido: DoughnutChart
      let percentage = this.fetchData.recivedPercentageWarehouse || 0
      percentage = this.$options.filters.formatDecimal(percentage)

      let chartColors = util.getChartColors(percentage)

      if (this.fetchData.recivedAmountWarehouse === 0 && this.fetchData.recivedAmountProjectionWarehouse === 0) {
        this.projectionChartDataReceived = {
          centerTextValue: percentage + '%',
          centerTextColor: chartColors.solid,
          labels: [
            'Sin Data'
          ],
          datasets: [
            {
              data: [
                100
              ],
              backgroundColor: [
                chartColors.opaque
              ]
            }
          ]
        }
      } else {
        this.projectionChartDataReceived = {
          centerTextValue: percentage + '%',
          centerTextColor: chartColors.solid,
          labels: [
            'Recibido',
            'Restante'
          ],
          datasets: [
            {
              data: [
                this.fetchData.recivedAmountWarehouse,
                this.fetchData.recivedAmountProjectionWarehouse - this.fetchData.recivedAmountWarehouse
              ],
              backgroundColor: [
                chartColors.solid,
                chartColors.opaque
              ]
            }
          ]
        }
      }

      // update center value
      if (this.$refs.chartReceived) {
        this.$refs.chartReceived.update(percentage + '%', chartColors.solid)
      }

      // Recibido: Line
      this.lineChartDataReceived = {
        labels: util.getChartLabels(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate),
        datasets: [
          {
            data: util.getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.recivedAmountValuesWarehouse),
            label: 'Recibido',
            borderColor: chartColors.solid,
            fill: false
          },
          {
            data: util.getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.recivedAmountProjectionValuesWarehouse),
            label: 'Proyectado',
            borderColor: this.colorProjected,
            fill: false
          }
        ]
      }
    },
    formatChartShipped () {
      // Despachado:DoughnutChart
      let percentage = this.fetchData.shippedPercentageWarehouse || 0
      percentage = this.$options.filters.formatDecimal(percentage)

      let chartColors = util.getChartColors(percentage)

      if (this.fetchData.shippedAmountWarehouse === 0 && this.fetchData.shippedAmountProjectionWarehouse === 0) {
        this.projectionChartDataShipped = {
          centerTextValue: percentage + '%',
          centerTextColor: chartColors.solid,
          labels: [
            'Sin Data'
          ],
          datasets: [
            {
              data: [
                100
              ],
              backgroundColor: [
                chartColors.opaque
              ]
            }
          ]
        }
      } else {
        this.projectionChartDataShipped = {
          centerTextValue: percentage + '%',
          centerTextColor: chartColors.solid,
          labels: [
            'Despachado',
            'Restante'
          ],
          datasets: [
            {
              data: [
                this.fetchData.shippedAmountWarehouse,
                this.fetchData.shippedAmountProjectionWarehouse - this.fetchData.shippedAmountWarehouse
              ],
              backgroundColor: [
                chartColors.solid,
                chartColors.opaque
              ]
            }
          ]
        }
      }

      // update center value
      if (this.$refs.chartShipped) {
        this.$refs.chartShipped.update(percentage + '%', chartColors.solid)
      }

      // Recibido: Line
      this.lineChartDataShipped = {
        labels: util.getChartLabels(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate),
        datasets: [
          {
            data: util.getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.shippedAmountValuesWarehouse),
            label: 'Despachado',
            borderColor: chartColors.solid,
            fill: false
          },
          {
            data: util.getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.shippedAmountProjectionValuesWarehouse),
            label: 'Proyectado',
            borderColor: this.colorProjected,
            fill: false
          }
        ]
      }
    },
    formatChartReturned () {
      this.lineChartDataReturn = {
        labels: util.getChartLabels(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate),
        datasets: [
          {
            data: util.getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.returnedAmountValuesWarehouse),
            label: 'Devoluciones',
            borderColor: this.colorReturned,
            fill: false
          }
        ]
      }
    },
    formatAmountColor (percentage) {
      let style = {
        color: util.getChartColors(percentage).solid
      }

      return style
    }
  },
  components: {
    'chart-projection-received': DoughnutChart,
    'chart-projection-shipped': DoughnutChart,
    'chart-line-return': LineChart
  }
}
</script>

<style>
.chartPadding {
  padding-left: 40px; 
  padding-right: 40px;
}
</style>



// WEBPACK FOOTER //
// WarehouseSummary.vue?6a3e8f80